import type { Bucket, TPagination } from 'src/types/s3';

import { memo } from 'react';

import Box from '@mui/material/Box';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import ListItemText from '@mui/material/ListItemText';
import ListItemButton from '@mui/material/ListItemButton';
import TablePagination from '@mui/material/TablePagination';

import ResponseLoader from '../../ChatResponseLoader';

type LeftSideProps = {
  bucketList: { buckets: Bucket[]; pagination: TPagination } | null;
  isLoadingBucketLIst: boolean;
  selectedBucket: string | null;
  handleBucketClick: (bucket: string) => void;
  pagination: { page: number; page_size: number };
  setPagination: React.Dispatch<React.SetStateAction<{ page: number; page_size: number }>>;
};

export const LeftSide = memo(
  ({
    bucketList,
    isLoadingBucketLIst,
    selectedBucket,
    handleBucketClick,
    pagination,
    setPagination,
  }: LeftSideProps) => (
    <>
      <Box sx={{ flexGrow: 1, overflow: 'auto', p: 2 }}>
        <List component="nav">
          {isLoadingBucketLIst ? (
            <Typography component="div">
              <ResponseLoader />
            </Typography>
          ) : (
            (bucketList?.buckets || []).map((bucket: Bucket) => (
              <ListItemButton
                key={bucket.name}
                selected={selectedBucket === bucket.name}
                onClick={() => handleBucketClick(bucket.name)}
              >
                <ListItemText>{bucket.name}</ListItemText>
              </ListItemButton>
            ))
          )}
        </List>
      </Box>
      <Box
        sx={{
          width: '90%',
          height: '12.5%',
          borderTop: '1px dashed #e0e0e0',
          alignSelf: 'center',
        }}
      >
        <TablePagination
          component="div"
          count={bucketList?.pagination.totalItems || 0}
          page={Math.min(
            pagination.page - 1,
            Math.max(
              0,
              Math.ceil((bucketList?.pagination.totalItems || 0) / pagination.page_size) - 1
            )
          )}
          rowsPerPage={pagination.page_size}
          onPageChange={(_, newPage) => {
            setPagination((prev) => ({ ...prev, page: newPage + 1 }));
          }}
          onRowsPerPageChange={(event) => {
            const newSize = parseInt(event.target.value, 10);
            setPagination((prev) => ({ ...prev, page_size: newSize, page: 1 }));
          }}
          rowsPerPageOptions={[]}
        />
      </Box>
    </>
  )
);
